<template>
    <div id="indexChartGauge"></div>
</template>

<script>
 import * as echarts from "echarts";
export default {
name: 'index-gauge-chart',
props: {
    collapsed: {
        type: Boolean,
    },
    yData: {
        type: Number,
        default: () => {
            return 0
        }
    }
},
data () {
  return {
  }
},
mounted () {
    var _this=this;
    window.addEventListener("resize", ()=>{
        if(_this.chartLine!=null){
            _this.chartLine.resize();
        }
    })
},
watch: {
    'yData': {
      handler (val) {
        this.drawLineChart();
      },
      deep: true
    },
    'collapsed': {
        handler (val) {
            if(this.chartLine!=null){
                this.chartLine.resize();
            }
        },
        deep: true
    },
},
methods: {
    drawLineChart:function() {
        this.chartLine = echarts.init(document.getElementById('indexChartGauge'));

        var option = {
            series: [
                {
                type: 'gauge',
                axisLine: {
                    lineStyle: {
                        width: 20,
                        color: [
                            [0.2, '#fd666d'],
                            [0.8, '#37a2da'],
                            [1, '#67e0e3']
                        ]
                    }
                },
                detail: {formatter: '{value}%'},
                radius: "90%",
                data: [
                    {
                        value: this.yData
                    }
                ]
                }
            ]
        };

        this.chartLine.setOption(option,true);
    },
}
}
</script>

<style lang="scss">
#indexChartGauge{
    width: 100%;
    height: calc(100% - 50px);
}
</style>



// WEBPACK FOOTER //
// IndexGaugeChart.vue?af9ae3e6